import {createContext} from "react";

export const defaultUserContextState = {
    userInfo: null,
    tokenInfo: null,
}
export const UserContext = createContext()
